import { render, staticRenderFns } from "./merchant-success.vue?vue&type=template&id=19c95635&scoped=true"
import script from "./merchant-success.vue?vue&type=script&lang=js"
export * from "./merchant-success.vue?vue&type=script&lang=js"
import style0 from "./merchant-success.vue?vue&type=style&index=0&id=19c95635&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c95635",
  null
  
)

export default component.exports